jQuery($ => {

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ AddBookmark
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $('.a-bookmark-trigger-button').on('add_bookmark', function (event, post_id, id, title, course_id) {
    var element = $(this);

    $.post(AJAX.url, {
      action: 'add_bookmark',
      post_id: post_id,
      anchor_id: id,
      section_title: title,
      fragments: FRAGMENTS,
      course_id: course_id,
    }, function (result) {
      if (result.success) {
        element.addClass('a-bookmark-trigger-button--active');
      }
    });
  });


  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ RemoveBookmark
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $('.a-bookmark-trigger-button').on('remove_bookmark', function (event, post_id, id, title, course_id) {
    var element = $(this);

    $.post(AJAX.url, {
      action: 'remove_bookmark',
      post_id: post_id,
      anchor_id: id,
      section_title: title,
      fragments: FRAGMENTS,
      course_id: course_id
    }, function (result) {
      if (result.success) {
        element.removeClass('a-bookmark-trigger-button--active');
      }
    });
  });


  $('body').on('remove_bookmark', '.js-remove-bookmark', function (event, post_id, id, title, course_id) {
    $.post(AJAX.url, {
      action: 'remove_bookmark',
      post_id: post_id,
      anchor_id: id,
      section_title: title,
      fragments: FRAGMENTS,
      course_id: course_id
    }, function (result) {
      if (result.success) {
        if (FRAGMENTS.header) {
          $('.m-bookmarks-menu__item').filter(`[data-id=${course_id}]`).html(result.data.fragments.header);
        }

        if (FRAGMENTS.course) {
          $(".m-accordion--bookmarks").html(result.data.fragments.course);
        }

        if (!$('.m-bookmarks-block')[0]) {
          $('.m-bookmarks-menu__text').removeClass('m-bookmarks-menu__text--hide');
        }
      }
    });
  });


  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ RemoveAllBookmarks
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $('body').on('remove_course_bookmarks', '.js-remove-course-bookmarks', function (event, course_id) {
    $.post(AJAX.url, {
      action: 'remove_course_bookmarks',
      course_id: course_id,
      fragments: FRAGMENTS
    }, function (result) {
      if (result.success) {

        if (FRAGMENTS.header) {
          $('.m-bookmarks-menu__item').filter(`[data-id=${course_id}]`).html(result.data.fragments.header);
        }

        if (FRAGMENTS.course) {
          $(".m-accordion--bookmarks").html(result.data.fragments.course);
        }

        if (!$('.m-bookmarks-block')[0]) {
          $('.m-bookmarks-menu__text').removeClass('m-bookmarks-menu__text--hide');
        }
      }
    });
  });


  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Atom: Bookmark Trigger Buttons
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  if ($('.a-bookmark-trigger-button')[0]) {
    $('.a-bookmark-trigger-button__button').click(function () {
      var parent = $(this).parent(),
        post_id = parent.attr('data-post-id'),
        course_id = parent.attr('data-course-id'),
        id = parent.attr('data-id'),
        title = parent.attr('data-title');

      if (!post_id) return;

      if (parent.hasClass('a-bookmark-trigger-button--active')) {
        parent.trigger('remove_bookmark', [post_id, id, title, course_id]);
      } else {
        parent.trigger('add_bookmark', [post_id, id, title, course_id]);
      }
    });
  }

  if ($('.js-remove-course-bookmarks')[0]) {
    $('body').on('click', '.js-remove-course-bookmarks', function () {
      var course_id = $(this).attr('data-id');

      if (!course_id) return;

      $(this).trigger('remove_course_bookmarks', [course_id]);
    });
  }

  if ($('.js-remove-bookmark')[0]) {
    $('body').on('click', '.js-remove-bookmark', function () {
      var post_id = $(this).attr('data-post-id'),
        id = $(this).attr('data-id'),
        course_id = $(this).attr('data-course-id') || FRAGMENTS.course,
        title = $(this).attr('data-title');

      if (!post_id) return;

      $(this).trigger('remove_bookmark', [post_id, id, title, course_id]);
    });
  }
});